/* eslint-disable no-template-curly-in-string */
import R from 'ramda'

const FACEBOOK_SEND_DM_INNER_ACTION_WIDGET_TYPE = 'SEND_FACEBOOK_MESSAGE'
const FACEBOOK_RECURRING_OPTOUT_DISPLAY_TYPE = 'Opt FB User out - Recurring'
const FACEBOOK_RECURRING_OPTOUT_WIDGET_TYPE = 'FB_OPT_OUT_RECURRING'

const isFacebookRecurringOptOutAction = R.propEq(
  'type',
  FACEBOOK_RECURRING_OPTOUT_DISPLAY_TYPE
)

const isPlainTextResponse = R.pipe(
  R.prop('fbOptOutRecurringAutoResponseImageUrl'),
  R.either(R.isNil, R.isEmpty)
)

const constructPlainTextResponse = R.applySpec({
  type: R.always(FACEBOOK_SEND_DM_INNER_ACTION_WIDGET_TYPE),
  message: {
    message: {
      text: R.prop('fbOptOutRecurringAutoResponseText')
    },
    recipient: {
      id: R.always('${senderId}')
    },
    messaging_type: R.always('RESPONSE')
  }
})

const constructImageTemplateAction = R.applySpec({
  type: R.always(FACEBOOK_SEND_DM_INNER_ACTION_WIDGET_TYPE),
  message: {
    message: {
      attachment: {
        type: R.always('template'),
        payload: {
          elements: [
            {
              title: R.prop('templateTitle'),
              subtitle: R.prop('fbOptOutRecurringAutoResponseText'),
              image_url: R.prop('fbOptOutRecurringAutoResponseImageUrl'),
              default_action: {
                url: R.prop('templateActionUrl'),
                type: R.always('web_url'),
                webview_height_ratio: R.always('tall')
              }
            }
          ],
          template_type: R.always('generic')
        }
      }
    },
    recipient: {
      id: R.always('${senderId}')
    }
  }
})

const constructGenericTemplateAction = R.cond([
  [isPlainTextResponse, constructPlainTextResponse],
  [R.T, constructImageTemplateAction]
])

const constructCustomTemplateAction = R.applySpec({
  type: R.always(FACEBOOK_SEND_DM_INNER_ACTION_WIDGET_TYPE),
  isCustomTemplate: R.always(true),
  message: R.pipe(
    R.prop('customDmTemplate'),
    JSON.parse,
    R.merge({ recipient: { id: '${senderId}' } })
  )
})

const convertFacebookRecurringOptOutActionToWidgetAction = R.applySpec({
  type: R.always(FACEBOOK_RECURRING_OPTOUT_WIDGET_TYPE),
  failure: R.always([]),
  success: [
    R.cond([
      [R.propEq('action', 'TEMPLATE_GENERIC'), constructGenericTemplateAction],
      [R.propEq('action', 'TEMPLATE_CUSTOM'), constructCustomTemplateAction]
    ])
  ]
})

export {
  isFacebookRecurringOptOutAction,
  convertFacebookRecurringOptOutActionToWidgetAction
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/facebook/form-to-widget/facebook-recurring-optout.js